import { render, staticRenderFns } from "./CampusViewHeader.vue?vue&type=template&id=2cba828e&"
import script from "./CampusViewHeader.vue?vue&type=script&lang=js&"
export * from "./CampusViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports